<template>
    <v-hover :disabled="disabled" v-slot="{ hover }">
      <v-card :disabled="disabled" :elevation="0" :color="color"  :class="{ 'small-button d-flex align-center pa-4': true, 'hover': hover, 'grey lighten-3': hover && (hasClickListener || to || href) }" @click="hasClickListener ? $emit('click') : null" :to="to" :href="href">
        <h4>{{title}}</h4>
        <v-spacer />
        <v-icon v-if="icon" size="25" :color="iconColor || 'grey'" class="d-inline-block">fal {{icon}}</v-icon>
        <v-icon size="25" :color="'grey'" class="ms-4 d-inline-block">fal fa-chevron-right</v-icon>
      </v-card>
    </v-hover>
    
</template>
 
<script>

export default {
  name: "SmallButton",
  components: {
  },
  props: {
    icon: String,
    iconColor: String,
    title: String,
    text: String,
    elevated: Boolean,
    disabled: Boolean,
    color: String,
    href: String,
    to: [Object, String],
  },
  data: function() {
    return {
    };
  },
  mounted() {
  },
  methods: {
      
  },
  computed: {
    hasClickListener(){
      return this.$listeners && this.$listeners.click;
    }
  }
};
</script>

<style lang="scss">
.v-application .small-button.v-card { border: 1px solid #ccc !important; border-radius: 8px !important; }
</style>

        